import React from 'react';
import { MinusOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from '@hooks/index';
import styles from './PanelMinimizeButton.module.css';

type Props = {
  /**
   * Handler for minimize button click
   */
  onClick: () => void;
  /**
   * Optional tooltip text (defaults to translated 'Minimize')
   */
  tooltip?: string;
}

/**
 * Shared minimize button component for draggable panels
 * @param props - Component props
 */
const PanelMinimizeButton = (props: Props) => {
  const { onClick, tooltip } = props;
  const t = useTranslation('CommonWords');
  const defaultTooltip = t('Minimize', 'Minimize');

  return (
    <Tooltip title={tooltip ?? defaultTooltip} placement="top">
      <Button
        type="text"
        icon={<MinusOutlined />}
        onClick={onClick}
        className={styles.MinimizeButton}
        size="small"
      />
    </Tooltip>
  );
};

export default PanelMinimizeButton;

